// REDUCER
import * as actionTypes from '../constants/actions';

const defaultState = {
};

function categoriesReceived(state, payload) {
	return {
		...state,
		...payload,
	};
}

export default function categoriesReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.CATEGORIES_RECV_DATA:
			return categoriesReceived(state, action.payload);
			break;
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/categories.js
 **/